module.exports = __webpack_public_path__ + "static/media/publish-24px.4a3a0a07.svg";